import * as tslib_1 from "tslib";
import { ServiceBase } from './service.base';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var PromotionLeaderboardService = /** @class */ (function (_super) {
    tslib_1.__extends(PromotionLeaderboardService, _super);
    function PromotionLeaderboardService(http) {
        var _this = _super.call(this, http) || this;
        _this.http = http;
        return _this;
    }
    PromotionLeaderboardService.prototype.getPromotionType = function (promotionId) {
        return this.getEndPoints("/lapi/leaderboard/" + promotionId + "/detail");
    };
    PromotionLeaderboardService.prototype.getMyInfo = function (qs, isPrizeHidden) {
        var params = {};
        if (!isPrizeHidden) {
            params.hasSummary = true;
        }
        if (qs.brandId) {
            params.brandId = qs.brandId;
        }
        if (qs.siteId) {
            params.siteId = qs.siteId;
        }
        return this.getEndPoints("/lapi/leaderboard/" + qs.promotionId + "/myinfo/" + qs.nickname, params);
    };
    PromotionLeaderboardService.prototype.getRankingPlayerList = function (qs, limit, isPrizeHidden) {
        if (limit === void 0) { limit = 10; }
        var url = "/lapi/leaderboard/" + qs.promotionId + "/" + encodeURIComponent(qs.nickname || '');
        var status = ['PENDING', 'OPTED_IN', 'COMPLETED', 'EXPIRED'];
        var params = {
            status: status
        };
        if (!!limit) {
            params.limit = Math.min(limit, 2500);
        }
        params.hasSummary = true;
        params.hasSummaryPaidPrizes = false;
        params.hasSummaryPrizeItem = false;
        if (isPrizeHidden) {
            params.forRank = true;
        }
        return this.getEndPoints(url, params, true);
    };
    PromotionLeaderboardService.prototype.getWsopNationalityLeaderboard = function (optInGroupName, limit) {
        if (limit === void 0) { limit = 10; }
        return this.getEndPoints("/lapi/leaderboard/wsop/" + optInGroupName, { limit: limit }, true);
    };
    PromotionLeaderboardService.prototype.getPrizePoolList = function (qs) {
        return this.getEndPoints("/lapi/leaderboard/" + qs.promotionId + "/prizes");
    };
    PromotionLeaderboardService.prototype.getPromotionGroup = function (groupId) {
        return this.getEndPoints("/lapi/leaderboard/groups/" + groupId, null, true);
    };
    PromotionLeaderboardService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function PromotionLeaderboardService_Factory() { return new PromotionLeaderboardService(i0.ɵɵinject(i1.HttpClient)); }, token: PromotionLeaderboardService, providedIn: "root" });
    return PromotionLeaderboardService;
}(ServiceBase));
export { PromotionLeaderboardService };
